module.exports = __webpack_public_path__ + "media/images/writer/monitor/mv-img@3x-077e405136df99f61e26fb56e92416f1.png";